export default (function (htmlString) {
  const pattern = /<p[^>]*>(.*?)<\/p>/g;
  const result = [];
  let match;
  const tagPattern = /<\/?[^>]+(>|$)/g;
  while ((match = pattern.exec(htmlString)) !== null) {
    result.push(match[1].replace(tagPattern, ''));
  }
  return result;
});